import { isSameDay } from 'date-fns';
import { DiscountType } from '~/models/DiscountModel';
import styles from '../BillClientModal.module.scss';
export const validateGreaterThan0 = (value)=>value && +value > 0;
export function getTableInfo(discount) {
    const tableInfo = [
        {
            headerItem: {
                value: 'Service name'
            },
            columnDef: {
                width: 248
            }
        },
        {
            headerItem: {
                value: 'Quantity',
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: 'Rate',
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: discount.type === DiscountType.Percent ? 'Discount' : 'Unit discount',
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: null
            },
            columnDef: {
                width: 130
            }
        },
        {
            headerItem: {
                value: 'Total',
                className: styles.headerAmountColumn
            },
            columnDef: {
                width: [
                    130,
                    276
                ]
            }
        }
    ];
    return {
        columnDefs: tableInfo.map((i)=>i.columnDef),
        headerItems: tableInfo.map((i)=>i.headerItem)
    };
}
export function getClientApprovalCalloutText(issueDate, invoiceDateInfo) {
    return (invoiceDateInfo === null || invoiceDateInfo === void 0 ? void 0 : invoiceDateInfo.invoiceDraftDates.dates().some((d)=>isSameDay(d, issueDate))) ? 'Adding an out-of-agreement charge to an existing invoice will require your client to manually approve the payment for the entire invoice' : 'Billing your client with out-of-agreement charges will require your client to manually approve the payment';
}
